import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'

const resource = createResource({
  en: {
    mainTitle: 'OUR TEAM',
    title1: 'Ronald Andi Kasim',
    subTitle1: 'President Director of PT Kredit Pintar Indonesia',
    desc1: `Before joining Kredit Pintar, Ronald Andi Kasim, CFA, held key leadership positions in several institutions including Chairman of Credit Bureau Indonesia, Country Director at Trusting Social, CEO at Pefindo Kredit Biro and Pefindo Credit Rating, and SVP at Bank Permata. He also served as Lead Analyst at Moody's Analytics. Ronald holds a Doctorate in Leadership & Policy Innovation from Universitas Gadjah Mada and earned his BSBA in Finance and MBA from Creighton University.`,
    title2: 'Darjoto Setyawan',
    subTitle2: 'President Commissioner of PT Kredit Pintar Indonesia',
    desc2: `Mr. Darjoto Setyawan is the President Commissioner of Kredit Pintar Indonesia. Prior to joining Kredit Pintar Indonesia, he worked in such well-known companies’ group in Indonesia as Bentoel Group, Semen Gresik, Eagle High, Nusantara Infrastructure. With Mr. Darjoto Setyawan's outstanding experience, Kredit Pintar Indonesia is set to contribute to the Indonesian economy as a digital solution for financial inclusion.`,
    title3: 'Wawan Salum',
    subTitle3: 'Commissioner of PT Kredit Pintar Indonesia',
    desc3: `Wawan Salum is the Commissioner of Kredit Pintar Indonesia. With excellent experiences in banking industry for more than 15 years, Wawan Salum was known to occupy various essential positions in several companies, such as Cards Marketing Director in Citi, Consumer Banking Director in HSBC, and Managing Director-Consumer Banking in DBS Bank. With exceptional track records and working experiences, Wawan Salum envisions Kredit Pintar Indonesia to be the company that gives huge contributions in financial inclusion acceleration in Indonesia.`,
  },
  id: {
    mainTitle: 'TIM KAMI',
    title1: 'Ronald Andi Kasim',
    subTitle1: 'President Direktur PT Kredit Pintar Indonesia',
    desc1: `Sebelum bergabung di Kredit Pintar, Ronald Andi Kasim, CFA, memegang posisi kunci di beberapa institusi termasuk Chairman dari Indonesia Credit Bureau, Country Director di Trusting Social, CEO di Pefindo Kredit Biro dan Pefindo Credit Rating, dan SVP di Permata Bank. Ia juga menjabat sebagai Analis Utama di Moody 's Analytics. Ronald memegang gelar Doktor dalam Kepemimpinan & Inovasi Kebijakan Universitas Gadjah Mada dan memperoleh gelar BSBA di bidang Keuangan dan MBA dari Creighton University.`,
    title2: 'Darjoto Setyawan',
    subTitle2: `Komisaris Utama PT Kredit Pintar Indonesia`,
    desc2: `Bapak Darjoto Setyawan merupakan Komisaris Utama dari Kredit Pintar Indonesia. Sebelumnya, Bapak Darjoto Setyawan telah berpengalaman di berbagai grup perusahaan-perusahaan ternama di Indonesia seperti Bentoel Group, Semen Gresik, Eagle High, Nusantara Infrastructure. Dengan kemampuan dan pengalaman mumpuni dari Bapak Darjoto Setyawan tersebut, Kredit Pintar Indonesia diharapkan mampu untuk menjadi perusahaan yang memberikan sumbangsih dalam perekonomian Indonesia sebagai salah satu solusi keuangan inklusif.`,
    title3: 'Wawan Salum',
    subTitle3: 'Komisaris PT Kredit Pintar Indonesia',
    desc3: `Wawan Salum merupakan Komisaris Kredit Pintar Indonesia. Dengan pengalaman di dunia perbankan selama lebih dari 15 tahun, Wawan Salum tercatat pernah menduduki jabatan penting dalam perusahaan, seperti Cards Marketing Director di Citi, Consumer Banking Director di HSBC, dan Managing Director-Consumer Banking di DBS Bank. Dengan rekam jejak dan pengalaman kerja yang mumpuni, Wawan Salum memiliki visi untuk membawa Kredit Pintar Indonesia untuk menjadi perusahaan yang mampu memberikan kontribusi besar terhadap percepatan inklusi keuangan di Indonesia.`,
  },
})

const IntroduceHook = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const FeatureList = [
    {
      img: '/images/about/about-one.png',
      title: t('title1'),
      subtitle: t('subTitle1'),
      desc: t('desc1'),
    },
    {
      img: '/images/about/about-two.png',
      title: t('title2'),
      subtitle: t('subTitle2'),
      desc: t('desc2'),
    },
    {
      img: '/images/about/about-three.png',
      title: t('title3'),
      subtitle: t('subTitle3'),
      desc: t('desc3'),
    },
  ]
  return (
    <Introduce>
      <div className="main-title">{t('mainTitle')}</div>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 ? (
          FeatureList.map((item, index) => (
            <div key={index} className="item">
              <div className="img">
                <Reveal delay={100 + index * 30} animation={Animation.FadeIn}>
                  <LazyLoad>
                    <img src={item.img} alt={item.title} />
                  </LazyLoad>
                </Reveal>
              </div>
              <div className="title">{item.title}</div>
              <div className="subtitle">{item.subtitle}</div>
              <div className="desc">{item.desc}</div>
            </div>
          ))
        ) : (
          <Swiper loop={true} pagination={{ clickable: true }} scrollbar={{ draggable: true }}>
            {FeatureList.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <div className="img">
                    <LazyLoad>
                      <img src={item.img} alt={item.title} />
                    </LazyLoad>
                  </div>
                  <div className="title">{item.title}</div>
                  <div className="subtitle">{item.subtitle}</div>
                  <div className="desc">{item.desc}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </Introduce>
  )
}

export default IntroduceHook

const Introduce = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 48px auto 0;
    text-align: center;
    width: 100%;
    .main-title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      padding-bottom: 24px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      .item {
        margin: 0 auto;
        text-align: left;
        width: 272px;
        .img {
          width: 160px;
          height: 160px;
        }
        .title {
          padding-top: 24px;
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 21px;
        }
        .subtitle {
          font-size: 18px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #1cc812;
          line-height: 21px;
          margin: 8px auto 16px;
          min-height: 42px;
        }
        .desc {
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 20px;
          margin-bottom: 30px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 90px 150px 72px;
    text-align: center;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    .main-title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      padding-bottom: 48px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      .item {
        width: 31%;
        text-align: left;
        .img {
          width: 160px;
          height: 160px;
        }
        .title {
          padding-top: 32px;
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #212121;
          line-height: 24px;
        }
        .subtitle {
          font-size: 24px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #1cc812;
          line-height: 24px;
          margin: 16px 0;
          min-height: 48px;
          width: 90%;
        }
        .desc {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #757575;
          line-height: 24px;
        }
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
`
